import {StorageAdapter} from '@/src/core/domain/data/storage'
import {injectable} from 'inversify'

@injectable()
export class LocalStorage implements StorageAdapter {
  async getItem<T>(key: string): Promise<T | null> {
    const value = localStorage.getItem(key)

    return (value && (JSON.parse(value) as T)) || null
  }

  async setItem(key: string, value: any): Promise<void> {
    localStorage.setItem(key, JSON.stringify(value))
  }

  async removeItem(key: string): Promise<void> {
    localStorage.removeItem(key)
  }
}
